import { keys } from "#/ui-kit/.generated/i18n/i18n-keys.generated";
import { createTypedIntl } from "@voltalis/frontend-tooling/i18n/runtime";

export const useCommonFrontendIntl = createTypedIntl(keys);
